import React, {useEffect, useState} from 'react';
import {
    IonModal,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonTextarea,
    IonInput,
    IonLabel,
    IonItem,
    IonFooter,
    IonRow,
    IonCol,
    useIonAlert, IonSearchbar, IonList, IonIcon, IonButtons,
} from '@ionic/react';
import {
    actionToEditUpdateRfpAssignmentDataById,
    actionToGetRfpAdminAssignmentDataByFilter, actionToGetRfpAssignmentDataByFilter, actionToGetUserAssignmentPostData,
    actionToUploadRfpAssignmentDataWithAttachment
} from "../apiHelpers/CommonAction";
import {_getIndianStates} from "../apiHelpers/CommonHelper";
import useStore from "../zustand/useStore";
import {arrowBack, star} from "ionicons/icons";
import moment from "moment-timezone";

export default function RaiseRFPModal({ isOpen,fromAdminList, onDismiss,dataForEditing,setIsLoading }) {
    const {userAuthDetail:{userInfo}} = useStore();
    const [form, setForm] = useState({
        title: '',
        scopeOfWork: '',
        location: '',
        city: '',
        price: '',
        email: userInfo?.email,
        expiryDate: '',
        pdf: null,
        retainership: 'Assignment' // default type
    });
    const {resetAssignmentFilters,setSelectedAssignmentMeMode,rfpAssignmentDataState} = useStore();
    const [errors, setErrors] = useState({});
    const [presentAlert] = useIonAlert();
    const [showPopover, setShowPopover] = useState(false);
    const [searchText, setSearchText] = useState("");

    const filteredStates = _getIndianStates.filter(state =>
        state.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        setForm(prev => ({ ...prev, pdf: file }));
    };

    const validate = () => {
        const newErrors = {};
        if (!form.title) newErrors.title = 'Title is required';
        if (!form.scopeOfWork) newErrors.scopeOfWork = 'Scope of Work is required';
        if (!form.location) newErrors.location = 'Location is required';
        if (!form.city) newErrors.city = 'City is required';
        if (!form.price) newErrors.price = 'Price is required';
        if (!form.email) newErrors.email = 'Email is required';
        if (!form.expiryDate) newErrors.expiryDate = 'Expiry date is required';
        if(!dataForEditing?.id) {
            if (!form.pdf) newErrors.pdf = 'Assignment PDF is required';
        }
        if (!form.retainership) newErrors.retainership = 'RFP Type is required';
        return newErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // Example: form data ready to submit
        const formData = new FormData();
        formData.append('title', form.title);
        formData.append('scope_of_work', form.scopeOfWork);
        formData.append('location', form.location);
        formData.append('price', form.price);
        formData.append('email', form.email);
        formData.append('expiry_date', form.expiryDate);
        formData.append('city', form.city);
        formData.append('retainership', form.retainership);
        if(dataForEditing?.id) {
            formData.append('id', dataForEditing?.id);
            formData.append('existing_pdf_url', dataForEditing?.attched_pdf_url);
        }

        if(form.pdf){
            formData.append('pdf', form.pdf);
        }
        
        setIsLoading?.(true);

        if(dataForEditing?.id) {
            actionToEditUpdateRfpAssignmentDataById(formData)
                .then(() => {
                    setIsLoading?.(false);
                    resetAssignmentFilters();
                    if (fromAdminList) {
                        actionToGetRfpAdminAssignmentDataByFilter(false,{offset:rfpAssignmentDataState?.offset});
                    } else {
                        setSelectedAssignmentMeMode(true);
                        actionToGetRfpAssignmentDataByFilter(true,{me_mode:true});
                        actionToGetUserAssignmentPostData();
                    }
                    onDismiss();
                })
                .catch(() => {
                    setIsLoading?.(false);
                    presentAlert({
                        message: 'Something went wrong while uploading.',
                        buttons: ['OK'],
                    });
                });
        }else{
            actionToUploadRfpAssignmentDataWithAttachment(formData)
                .then(() => {
                    setIsLoading?.(false);
                    if (fromAdminList) {
                        actionToGetRfpAdminAssignmentDataByFilter(true);
                    } else {
                        setSelectedAssignmentMeMode(true);
                        actionToGetRfpAssignmentDataByFilter(true,{me_mode:true});
                        actionToGetUserAssignmentPostData();
                    }
                    resetAssignmentFilters();
                    onDismiss();
                })
                .catch(() => {
                    setIsLoading?.(false);
                    presentAlert({
                        message: 'Something went wrong while uploading.',
                        buttons: ['OK'],
                    });
                });
        }
    };

    useEffect(() => {
        if (isOpen) {
            if (dataForEditing?.id) {
                setForm({
                    title: dataForEditing?.title,
                    scopeOfWork: dataForEditing?.scope_of_work,
                    location: dataForEditing?.location,
                    price: dataForEditing?.price,
                    email: dataForEditing?.email || userInfo?.email,
                    city: dataForEditing?.city,
                    expiryDate: moment(dataForEditing?.expiry_date).format('YYYY-MM-DD'),
                    retainership: dataForEditing?.retainership // default type
                });
            } else {
                setForm({
                    title: '',
                    scopeOfWork: '',
                    location: '',
                    price: '',
                    email: userInfo?.email,
                    city: '',
                    expiryDate: '',
                    pdf: null,
                    retainership: 'Assignment' // default type
                });
            }
        }
    }, [isOpen, dataForEditing]);

    return (
        <IonModal className="sheet_modal_header" isOpen={isOpen} onDidDismiss={onDismiss} breakpoints={[0, 1]} initialBreakpoint={1}>
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Raise RFP</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">

                <div className="rfp_submit_form_item">
                    <div className="rfp-type-toggle">
                        <button
                            className={`rfp-type-toggle-btn ${form.retainership === 'Retainership' ? 'active' : ''}`}
                            onClick={() => handleChange('retainership', 'Retainership')}>Retainership
                        </button>
                        <button className={`rfp-type-toggle-btn ${form.retainership === 'Assignment' ? 'active' : ''}`}
                                onClick={() => handleChange('retainership', 'Assignment')}>Assignment
                        </button>
                    </div>
                </div>

                <div className="rfp_submit_form_item">
                    <IonLabel>Title<IonIcon icon={star} className="required-star" /></IonLabel>
                    <IonInput
                        className="rfp_form_input"
                        placeholder="Enter title"
                        value={form.title}
                        onIonInput={e => handleChange('title', e.detail.value)}
                    />
                    {errors.title && <p className="error-text">{errors.title}</p>}
                </div>

                <div className="rfp_submit_form_item">
                    <IonLabel>Scope of Work<IonIcon icon={star} className="required-star" /></IonLabel>
                    <IonTextarea
                        className="rfp_form_input"
                        placeholder="Describe the scope of work..."
                        rows={3}
                        maxlength={1000}
                        value={form.scopeOfWork}
                        onIonInput={e => handleChange('scopeOfWork', e.detail.value)}
                    />
                    {errors.scopeOfWork && <p className="error-text">{errors.scopeOfWork}</p>}
                </div>

                <div className="rfp_submit_form_item">
                    <IonLabel>City<IonIcon icon={star} className="required-star" /></IonLabel>
                    <IonInput
                        className="rfp_form_input"
                        type="text"
                        placeholder="Enter city"
                        value={form.city}
                        onIonInput={e => handleChange('city', e.detail.value)}
                    />
                    {errors.city && <p className="error-text">{errors.city}</p>}
                </div>

                <div className={"rfp_submit_form_item"}>
                    <IonLabel>Location<IonIcon icon={star} className="required-star" /></IonLabel>
                    <div onClick={() => setShowPopover(true)} className={"select_popup_injecttor_sele"}>
                        {form?.location ? <span className={"actual_selection"}>{form?.location}</span> :
                            <span className={"select_place_holder"}>Select Location <svg
                                xmlns="http://www.w3.org/2000/svg" fill="#5e5e5e" width="10px" height="10px" className="ionicon" viewBox="0 0 512 512"><path
                                d="M64 144l192 224 192-224H64z"></path></svg></span>}
                    </div>

                    <IonModal
                        isOpen={showPopover}
                        onDidDismiss={() => setShowPopover(false)}
                        cssClass="custom-alert-modal"
                    >
                        <div className="custom-alert-box">
                            <h2 className="alert-title">Select Location</h2>

                            <IonSearchbar
                                value={searchText}
                                onIonInput={(e) => setSearchText(e.detail.value)}
                                placeholder="Search..."
                            />

                            <IonList className="alert-list">
                                {filteredStates.map((state, idx) => (
                                    <IonItem
                                        key={idx}
                                        button
                                        onClick={() => {
                                            handleChange("location", state);
                                            setShowPopover(false);
                                        }}
                                    >
                                        {state}
                                    </IonItem>
                                ))}
                            </IonList>
                        </div>
                    </IonModal>
                    {errors.location && <p className="error-text">{errors.location}</p>}
                </div>

            <div className="rfp_submit_form_item">
                <IonLabel>Minimum Price Offered (INR)<IonIcon icon={star} className="required-star" /></IonLabel>
                <IonInput
                    className="rfp_form_input"
                    type="number"
                    placeholder="Enter price"
                    value={form.price}
                    onIonInput={e => handleChange('price', e.detail.value)}
                />
                {errors.price && <p className="error-text">{errors.price}</p>}
            </div>

            <div className="rfp_submit_form_item">
                <IonLabel>Assignment PDF<IonIcon icon={star} className="required-star" /></IonLabel>
                <IonItem className="ion-no-padding ion-margin-bottom">
                <input
                                className="attach-pdf"
                                type="file"
                                accept="application/pdf"
                                onChange={handleFileUpload}
                            />
                        </IonItem>
                        {errors.pdf && <p className="error-text">{errors.pdf}</p>}
                    </div>

                    <div className="rfp_submit_form_item">
                        <IonLabel>Email ID<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            type="email"
                            className="rfp_form_input"
                            placeholder="Enter email"
                            value={form.email}
                            onIonInput={e => handleChange('email', e.detail.value)}
                        />
                        {errors.email && <p className="error-text">{errors.email}</p>}
                    </div>

                    <div className="rfp_submit_form_item">
                        <IonLabel>Expiry Date<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            type="date"
                            className="rfp_form_input"
                            placeholder="Select expiry date"
                            value={form.expiryDate}
                            onIonInput={e => handleChange('expiryDate', e.detail.value)}
                        />
                        {errors.expiryDate && <p className="error-text">{errors.expiryDate}</p>}
                    </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={onDismiss}>Close</IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton className="apply_job_button" expand="block" onClick={handleSubmit}>Submit</IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
